var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 200 200",
      "width": "200",
      "height": "200",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "100",
      "fill": "#2196F3"
    }
  }), _c('path', {
    attrs: {
      "d": "M100 0C155.228 0 200 44.772 200 100C200 155.228 155.228 200 100 200V0Z",
      "fill": "#1E7FCE"
    }
  }), _c('path', {
    attrs: {
      "d": "M55 50a10 10 0 0 1 10-10h48l32 32v78a10 10 0 0 1-10 10H65a10 10 0 0 1-10-10V50z",
      "fill": "#2A3B4F"
    }
  }), _c('path', {
    attrs: {
      "d": "M61 54a6 6 0 0 1 6-6h42l28 28v74a6 6 0 0 1-6 6H67a6 6 0 0 1-6-6V54z",
      "fill": "#FFF6E8"
    }
  }), _c('path', {
    attrs: {
      "d": "M109 48v28h28L109 48z",
      "fill": "#E8D4B8"
    }
  }), _c('rect', {
    attrs: {
      "x": "74",
      "y": "92",
      "width": "44",
      "height": "5",
      "rx": "2.5",
      "fill": "#2A3B4F",
      "opacity": "0.2"
    }
  }), _c('rect', {
    attrs: {
      "x": "74",
      "y": "106",
      "width": "36",
      "height": "5",
      "rx": "2.5",
      "fill": "#2A3B4F",
      "opacity": "0.16"
    }
  }), _c('rect', {
    attrs: {
      "x": "74",
      "y": "120",
      "width": "40",
      "height": "5",
      "rx": "2.5",
      "fill": "#2A3B4F",
      "opacity": "0.12"
    }
  }), _c('rect', {
    attrs: {
      "x": "74",
      "y": "134",
      "width": "28",
      "height": "5",
      "rx": "2.5",
      "fill": "#2A3B4F",
      "opacity": "0.1"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }